import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { Button } from "../../ui/button"
import { ArrowLeft } from "lucide-react"
import { VersionHistoryHeader } from "./version-history-header"
import { VersionHistoryContent } from "./version-history-content"
import { getVideoVersionHistory, updateVideoStatus } from "../live-campaign-repository"
import CustomAlert from "../../common/alert";

const VersionHistoryPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { campaignId, creatorId } = location.state || {};
  const [videoVersionHistory, setVideoVersionHistory] = useState();
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [statusChanges, setStatusChnage] = useState();

  const showAlert = (severity, message) => {
    setAlertSeverity(severity);
    setAlertMessage(message);
    setAlertOpen(true);
    setTimeout(() => {
      setAlertOpen(false);
    }, 30000);
  };

  const handleStatusChange = (videoVersion, status) => {
    updateVideoStatus(campaignId, creatorId, videoVersion, status)
      .then((response) => {
        if (response?.error) {
          showAlert("error", `Failed to update status. Please try again.`);
        } else {
          setStatusChnage(Math.random().toString(36).substring(7));
          showAlert("success", `Status updated successfully.`);
        }
      })
      .catch((err) => {
        showAlert("error", `Failed to update status. Please try again.`);
      });
  }

  useEffect(() => {
    getVideoVersionHistory(campaignId, creatorId, setVideoVersionHistory);
  }, [campaignId, creatorId, statusChanges]);

  return (
    <div className="p-4 md:p-6 space-y-6">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="text-gray-600 hover:text-gray-800"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Status Details
        </Button>
      </div>

      {videoVersionHistory && videoVersionHistory.videoVersions && videoVersionHistory.videoVersions.length > 0 ? (
        <>
          <VersionHistoryHeader videoVersionHistory={videoVersionHistory} />
          <VersionHistoryContent videoVersionHistory={videoVersionHistory} handleStatusChange={handleStatusChange} />
        </>
      ) : (
        <div style={{ textAlign: 'center', padding: '2rem', color: '#888' }}>
          No video history found
        </div>
      )
      }
      <CustomAlert
        open={alertOpen}
        severity={alertSeverity}
        message={alertMessage}
        onClose={() => setAlertOpen(false)}
      />
    </div>
  )
}

export default VersionHistoryPage
